export default "__VITE_ASSET__fAKWYaBM__"